import { render, staticRenderFns } from "./MedRecordTemplateUpdate.vue?vue&type=template&id=d32a4f1a"
import script from "./MedRecordTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./MedRecordTemplateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports